import { lazy, Suspense, useEffect, useState } from "react";
import Loader from "../components/loaders/loader";
import { Navigate, Route, Routes } from "react-router-dom";
import SplashScreen from "../components/splashScreen";
import SliderSkeleton from "../components/slider/simpleSlider/loader";

const Home = lazy(() => import("../features/home"));
const Destination = lazy(() => import("../features/destinations"));
const DestinationInfo = lazy(() => import("../features/destinations/destinationInfo"));
const Packages = lazy(() => import("../features/packagesList"));
const PackageDetails = lazy(() => import("../features/packageDetails"));
const BlogList = lazy(() => import("../features/websiteContent/blog"));
const BlogDetails = lazy(() => import("../features/websiteContent/blog/blogDetails"));
const BlogArtical = lazy(() => import("../features/websiteContent/blog_artical"));
const BrochureViewer = lazy(() => import("../features/websiteContent/blog_artical/brochureViewer"));
const AirportList = lazy(() => import("../features/destinations/airport"));
const AirportInfo = lazy(() => import("../features/destinations/airport/info"));
const ArticleList = lazy(() => import("../features/websiteContent/article"));
const ArticleDetails = lazy(() => import("../features/websiteContent/article/details"));
const About = lazy(() => import("../features/websiteContent/about"));
const AboutUsNew = lazy(() => import("../features/websiteContent/aboutUs_new"));
const VisaDocuments = lazy(() => import("../features/websiteContent/visaDocuments"));
const VisaDocumentsDetails = lazy(() => import("../features/websiteContent/visaDocuments/details"));
const FirstTravellers = lazy(() => import("../features/websiteContent/firstTravellers"));
const FirstTravellerDetails = lazy(() => import("../features/websiteContent/firstTravellers/details"));
const HealthMedical = lazy(() => import("../features/websiteContent/healthMedical"));
const HealthMedicalDetails = lazy(() => import("../features/websiteContent/healthMedical/details"));
const Contact = lazy(() => import("../features/contact/index"));
const AgentReview = lazy(() => import("../features/websiteContent/review"));
const AgentReviewDetails = lazy(() => import("../features/websiteContent/review/details"));
const Maintenance = lazy(() => import("../features/maintenancePage"));
const Registration = lazy(() => import("../features/partnersZone/agent/registration"));
const UserRegistration = lazy(() => import("../features/endUser/registration"));
const GroupWeddings = lazy(() => import("../features/websiteContent/groupWeddings"));
const WhatWeDo = lazy(() => import("../features/websiteContent/whatWeDo"));
const BookManage = lazy(() => import("../features/bookManage"));
const Careers = lazy(() => import("../features/websiteContent/careers"));
const PrivacyPolicy = lazy(() => import("../features/websiteContent/privacyPolicy"));
const Cookies = lazy(() => import("../features/websiteContent/cookies"));
const RefundPolicy = lazy(() => import("../features/websiteContent/refundPolicy"));
const TermsCondition = lazy(() => import("../features/websiteContent/termsCondition"));
const Disruption = lazy(() => import("../features/websiteContent/disruption"));
const CSRPolicy = lazy(() => import("../features/websiteContent/csrPolicy"));
const Accessibility = lazy(() => import("../features/websiteContent/accessibility"));
const AgentsRights = lazy(() => import("../features/websiteContent/agentsRights"));
const NewsDetails = lazy(() => import("../features/home/news/details"));
const NewsRoom = lazy(() => import("../features/websiteContent/newsRoom"));
const NewsroomDetails = lazy(() => import("../features/websiteContent/newsRoom/details"));
const OurStrengths = lazy(() => import("../features/websiteContent/ourStrengths"));
const Testimonials = lazy(() => import("../features/websiteContent/testimonials"));
const Visa = lazy(() => import("../features/websiteContent/visa"));
const VisaAssistance = lazy(() => import("../features/websiteContent/visaAssistance"));
const Passport = lazy(() => import("../features/websiteContent/passport"));
const PassportDetails = lazy(() => import("../features/websiteContent/passport/details"));
const ChecklistPdf = lazy(() => import("../features/websiteContent/checklistPdf"));
const BecomeSalesPartner = lazy(() => import("../features/partnersZone/becomeSales"));
const TravelAgent = lazy(() => import("../features/partnersZone/travelAgent"));
const PartnersLogin = lazy(() => import("../features/partnersZone/partnersLogin"));
const ItineraryPreview = lazy(() => import("../features/itineraryPreview"));
const TermConditionPreview = lazy(() => import("../features/termConditionPreview"));
// const HowToBook = lazy(() => import("../features/websiteContent/howToBook"));
const OurTeam = lazy(() => import("../features/websiteContent/ourTeam"));
const TourManager = lazy(() => import("../features/websiteContent/tourManager"));
const SafetyGuidelines = lazy(() => import("../features/websiteContent/safetyGuidelines"));
// const CorporateGovernance = lazy(() => import("../features/websiteContent/corporateGovernance"));
// const LeaveFeedback = lazy(() => import("../features/websiteContent/leaveYourFeedback"));
const PageNotFound = lazy(() => import("../features/page-not-found"));

export default function Router({
    showLogin,
    setShowLogin
}: any) {
    const [loader, setLoader] = useState(true);
    useEffect(() => {
        setTimeout(() => {
            setLoader(false);
        }, 3000);
    }, []);

    return (
        <>
            {/* <Suspense fallback={<div><Loader /></div>}> */}
            <Suspense>
                <Routes>
                    <Route path="/" element={
                        <Suspense fallback={<SplashScreen />}>
                            <Suspense fallback={<SliderSkeleton />}>
                                {loader && <SliderSkeleton />}
                                <Home />
                            </Suspense>
                        </Suspense>
                    } />
                    <Route path='/home' element={<Home />} />
                    <Route path='/destination' element={<Destination />} />
                    <Route path='/destinationinfo/:decodeid' element={<DestinationInfo />} />
                    <Route path='/destinationinfo/:decodeid/:name' element={<DestinationInfo />} />
                    <Route path='/packages' element={<Packages />} />
                    <Route path='/packages/:decodeid/:decodetype' element={<Packages />} />
                    <Route path='/packages/:decodeid/:decodetype/:name' element={<Packages />} />
                    <Route path='/package/:decodeid' element={
                        <Suspense fallback={<SplashScreen />}>
                            <PackageDetails />
                        </Suspense>
                    } />
                    <Route path='/package/:decodeid/:name' element={
                        <Suspense fallback={<SplashScreen />}>
                            <PackageDetails />
                        </Suspense>
                    } />
                    <Route path='/blogs' element={<BlogList />} />
                    <Route path='/blogdetails/:decodeid' element={<BlogDetails />} />
                    <Route path='/blogdetails/:decodeid/:name' element={<BlogDetails />} />
                    <Route path='/blog-artical' element={<BlogArtical />} />
                    <Route path='/e-brochure/:slug' element={<BrochureViewer />} />
                    <Route path='/airport' element={<AirportList />} />
                    <Route path='/airportInformation/:decodeid' element={<AirportInfo />} />
                    <Route path='/airportInformation/:decodeid/:name' element={<AirportInfo />} />
                    <Route path='/articles' element={<ArticleList />} />
                    <Route path='/articles/:decodeid' element={<ArticleList />} />
                    <Route path='/articleDetails/:decodeid' element={<ArticleDetails />} />
                    <Route path='/articleDetails/:decodeid/:name' element={<ArticleDetails />} />
                    <Route path='/about' element={<About />} />
                    <Route path='/about-us' element={<AboutUsNew />} />
                    <Route path='/aboutUs_new' element={<AboutUsNew />} />
                    <Route path='/about-us-new' element={<AboutUsNew />} />
                    <Route path='/visadocuments' element={<VisaDocuments />} />
                    <Route path='/visadocumentsdetails/:decodeid' element={<VisaDocumentsDetails />} />
                    <Route path='/visadocumentsdetails/:decodeid/:name' element={<VisaDocumentsDetails />} />
                    <Route path='/firstTravellers' element={<FirstTravellers />} />
                    <Route path='/firstTravellersdetails/:decodeid' element={<FirstTravellerDetails />} />
                    <Route path='/firstTravellersdetails/:decodeid/name' element={<FirstTravellerDetails />} />
                    <Route path='/healthMedical' element={<HealthMedical />} />
                    <Route path='/healthMedicalDetails/:decodeid' element={<HealthMedicalDetails />} />
                    <Route path='/healthMedicalDetails/:decodeid/:name' element={<HealthMedicalDetails />} />
                    <Route path='/contact' element={<Contact />} />
                    <Route path='/agentReview' element={<AgentReview />} />
                    <Route path='/agentreviewDetails/:decodeid' element={<AgentReviewDetails />} />
                    <Route path='/agentreviewDetails/:decodeid/:name' element={<AgentReviewDetails />} />
                    <Route path='/maintenance' element={<Maintenance />} />
                    <Route path='/agentregistration' element={
                        <Registration
                            showLogin={showLogin}
                            setShowLogin={setShowLogin}
                        />
                    } />
                    <Route path='/registration' element={
                        // <Registration
                        <UserRegistration
                            showLogin={showLogin}
                            setShowLogin={setShowLogin}
                        />
                    } />
                    <Route path='/groupWeddings' element={<GroupWeddings />} />
                    <Route path='/whatWeDo' element={<WhatWeDo />} />
                    <Route path='/whatWeDo/:decodeid/:name' element={<WhatWeDo />} />
                    <Route path='/bookManage' element={<BookManage />} />
                    <Route path='/careers' element={<Careers />} />
                    <Route path='/terms-condition' element={<TermsCondition />} />
                    <Route path='/privacy-policy' element={<PrivacyPolicy />} />
                    <Route path='/refund-policy' element={<RefundPolicy />} />
                    <Route path='/cookies' element={<Cookies />} />
                    <Route path='/disruption' element={<Disruption />} />
                    <Route path='/csr-policy' element={<CSRPolicy />} />
                    <Route path='/accessibility' element={<Accessibility />} />
                    <Route path='/agents-rights' element={<AgentsRights />} />
                    <Route path='/newsdetails/:decodeid' element={<NewsDetails />} />
                    <Route path='/newsdetails/:decodeid/:name' element={<NewsDetails />} />
                    <Route path='/newsroom' element={<NewsRoom />} />
                    <Route path='/newsroomdetails/:decodeid' element={<NewsroomDetails />} />
                    <Route path='/newsroomdetails/:decodeid/:name' element={<NewsroomDetails />} />
                    <Route path='/our-strengths' element={<OurStrengths />} />
                    <Route path='/testimonials' element={<Testimonials />} />
                    <Route path='/testimonials/:decodeid/:name' element={<Testimonials />} />
                    <Route path='/visa' element={<Visa />} />
                    <Route path='/visaAssistance' element={<VisaAssistance />} />
                    <Route path='/visa-assistance' element={<VisaAssistance />} />
                    <Route path='/passport' element={<Passport />} />
                    <Route path='/passportdetails' element={<PassportDetails />} />
                    <Route path='/passportdetails/:decodeid' element={<PassportDetails />} />
                    <Route path='/checklist-pdf' element={<ChecklistPdf />} />
                    <Route path='/become-sales-partner' element={<BecomeSalesPartner />} />
                    <Route path='/sales-partners' element={<Contact />} />
                    <Route path='/travel-agent' element={<TravelAgent />} />
                    <Route path='/partners-login' element={<PartnersLogin />} />
                    <Route path='/how-to-book' element={<Navigate to='/contact' replace />} />
                    <Route path='/our-team' element={<OurTeam />} />
                    <Route path='/tour-manager' element={<TourManager />} />
                    <Route path='/safety-guidelines' element={<SafetyGuidelines />} />
                    <Route path='/corporate-governance' element={<Navigate to='/contact' replace />} />
                    <Route path='/leave-feedback' element={<Navigate to='/contact' replace />} />
                    <Route path='/contact-support' element={<Navigate to='/contact' replace />} />
                    <Route path='/help-centre' element={<Navigate to='/contact' replace />} />
                    <Route path='/help-center' element={<Navigate to='/contact' replace />} />
                    <Route path='/faqs' element={<Navigate to='/contact' replace />} />
                    <Route path='/faq' element={<Navigate to='/contact' replace />} />
                    <Route path='/contact-us' element={<Navigate to='/contact' replace />} />
                    <Route path='/our-strengths/:decodeid/:name' element={<OurStrengths />} />
                    <Route path='/itinerary-preview/:decodepackageid/:decodeitinerarydateid/:decodecategorydeparturecityid/:decodedeparturedate/:name' element={<ItineraryPreview />} />
                    <Route path="/terms-condition-preview" element={<TermConditionPreview />} />
                    <Route path="/not-found" element={<PageNotFound />} />
                    <Route path='*' element={<PageNotFound />} />

                </Routes>
            </Suspense>
        </>
    )
}